import CreateView from "../../../custom/CreateView";
import React, {useCallback, useState} from "react";
import {InputType} from "../../../../common/FormRenderer";
import {find} from "lodash";
import {useGetLineAdsAccountListQuery} from "../../../../generated/graphql";

export default ({onSelectAccount}) => {
    const [selectedAccount, setSelectedAccount] = useState<any>();
    const { data: accounts, loading, error } = useGetLineAdsAccountListQuery();

    const accountColumns = [
        {
            name: "lineAdsAccount",
            label: "LINE廣告帳戶",
            type: InputType.autoComplete,
            options: accounts?.lineAdsAccounts?.map((account)=>{
                return {value: account.id, label: `${account.id}-${account.name}`};
            }),
            onChange: (d) => {
                setSelectedAccount(find(accounts?.lineAdsAccounts ?? [], (c)=>{
                    return c.id == d;
                }));
            },
        },
    ];

    const onSubmit = useCallback(
        async (account, { resetForm }, setOpen) => {
            onSelectAccount(selectedAccount);
            setOpen(false);
        },[selectedAccount, onSelectAccount]
    );

    return (
        <CreateView
            title={"新增LINE廣告帳戶"}
            columns={accountColumns}
            onSubmit={onSubmit}
            queryEntity={"accountLineAds"}
        />
    );
};
